export function getTimeAgoText(date: Date): string {
    const now = new Date()
    const elapsedMilliseconds = now.getTime() - date.getTime()

    const seconds = Math.floor(elapsedMilliseconds / 1000)
    const minutes = Math.floor(seconds / 60)
    const hours = Math.floor(minutes / 60)
    const days = Math.floor(hours / 24)
    const months = Math.floor(days / 30) // Approximation
    const years = Math.floor(days / 365) // Approximation

    if (years > 0) {
        return years === 1 ? "1 anno fa" : `${years} anni fa`
    }

    if (months > 0) {
        return months === 1 ? "1 mese fa" : `${months} mesi fa`
    }

    if (days > 0) {
        return days === 1 ? "ieri" : `${days} giorni fa`
    }

    if (hours > 0) {
        return hours === 1 ? "1 ora fa" : `${hours} ore fa`
    }

    if (minutes > 0) {
        return minutes === 1 ? "1 minuto fa" : `${minutes} minuti fa`
    }

    return "proprio adesso"
}
